__turbopack_context__.v({
  "editor": "RichTextEditor-module-scss-module__1xaEnW__editor",
  "error": "RichTextEditor-module-scss-module__1xaEnW__error",
  "mentionContainer": "RichTextEditor-module-scss-module__1xaEnW__mentionContainer",
  "multilinePlaceholder": "RichTextEditor-module-scss-module__1xaEnW__multilinePlaceholder",
  "root": "RichTextEditor-module-scss-module__1xaEnW__root",
});
